import request from 'axios';


export const POSTS_GET = 'POSTS_GET';
export const SELECT_TOUR = 'SELECT_TOUR';
export const POSTS_GET_REQUEST = 'POSTS_GET_REQUEST';
export const POSTS_GET_SUCCESS = 'POSTS_GET_SUCCESS';


var apiUrl = '';
if(process.env.NODE_ENV !== 'production'){

  apiUrl = 'https://a.baikalnatu.re/';
}else{

  apiUrl = 'https://a.baikalnatu.re/';

}





// WEBPACK FOOTER //
// ./src/common/actions/tour.js